import _slicedToArray from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { expandSizes } from './expandSizes';
/**
 * Merges two given shorthand lists
 *
 * @template S
 * @param {S[]} shorthand List of up to four sizes defined using CSS shorthand pattern
 * @param {S[]} overrides List of up to four override sizes defined using CSS shorthand pattern
 * @returns {S[]}
 */

export function mergeSizes() {
  var shorthand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var expandedShorthand = expandSizes(shorthand);

  var _expandSizes = expandSizes(overrides),
      _expandSizes2 = _slicedToArray(_expandSizes, 4),
      _expandSizes2$ = _expandSizes2[0],
      blockStart = _expandSizes2$ === void 0 ? expandedShorthand[0] : _expandSizes2$,
      _expandSizes2$2 = _expandSizes2[1],
      inlineEnd = _expandSizes2$2 === void 0 ? expandedShorthand[1] : _expandSizes2$2,
      _expandSizes2$3 = _expandSizes2[2],
      blockEnd = _expandSizes2$3 === void 0 ? expandedShorthand[2] : _expandSizes2$3,
      _expandSizes2$4 = _expandSizes2[3],
      inlineStart = _expandSizes2$4 === void 0 ? expandedShorthand[3] : _expandSizes2$4;

  return [blockStart, inlineEnd, blockEnd, inlineStart];
}